import merge from "../functions/merge";
import store from '../../store.js'
import InvoiceWindow from '../windows/InvoiceWindow';
import { bus } from '../../bus';

export default {
	entity() {
		var valid_to = new Date();
		valid_to.setDate(valid_to.getDate() + 30);

		var next_contact = new Date();
		next_contact.setDate(next_contact.getDate() + 7);

		return merge({}, {
			_embedded: {
				contact: {
					name: '',
					address: '',
					zip: '',
					city: ''
				},
				employee: {
					name: ''
				},
				tasks: [],
				approvals: []
			},
	
			contact_id: null,
			department_id: null,
			employee_id: null,
			margin_adjust: 0,
			remarks: '',
			remarks_all: '',
	
			customer: {
				name: '',
				att: '',
				address: {
					address: '',
					zip: '',
					city: '',
					country: ''
				},
				phone: '',
				email: '',
				numbers: {}
			},

			files: [],
			auto_gen: false,
	
			comments: '',
			description: '',
			order_lines: [],
			email_status: '',
			//next_contact: next_contact.format('Y-m-d'),
			//valid_to: valid_to.format('Y-m-d')
			status: 'open',
			
			invoiced_total: '',

			template_id: null,
			template:{
				storage: 0,
				storage_vat: false,
				incl: [],
				extra: '',
				ps: ''
			},
		});
	},
	async after(axios, order, invoice, paid) {
		
		const self = this;
		
		if (invoice) {
			
			store.state.windowStack.push(InvoiceWindow, {
				value: order, 
				submit: async function (inv) {
					if (await self.invoice(axios, order, inv)) {
						store.state.windowStack.pop();
						store.state.windowStack.pop();
						bus.$emit('update');
					}
				}
			});
		} else if (paid) {
			
			const paidStatus = await self.paid(axios, order, paid);

			

			if (paidStatus) {
				store.state.windowStack.pop();
				bus.$emit('update');
			}
		} else {
			
			store.state.windowStack.pop();
			bus.$emit('update');
		}
	},
	save(axios, entity, invoice, paid) {
		const self = this;

		return new Promise(function (resolve) {
			if (entity.id) {
				axios
					.put('/sales/orders/' + entity.id + '/booking-conflict/', entity)
					.then(function (r) {
						

						if (!r.data || (r.data && confirm('Du er ved at skifte dato på en eller flere opgaver. Dette vil slette alle tidligere bookinger. Er du sikker?'))) {
							axios
								.put('/sales/orders/' + entity.id + '/', entity)
								.then(function (r) {
									(async () => {
										
										await self.after(axios, r.data, invoice, paid);
										
										resolve(r.data);
									})();
								}, function () {
									
								});
						}
					}, function () {
						// Nothing
						
					});
			} else {
				axios
					.post('/sales/orders/', entity)
					.then(function (r) {
						(async () => {
							
							await self.after(axios, r.data, invoice, paid);
							
							resolve(r.data);
						})();
					}, function () {
						
					});
			}
		});
	},
	read(axios, id) {
		return new Promise(function (resolve) {
			axios
				.get('/sales/orders/' + id + '/')
				.then(function (r) {
					resolve(r.data);
				}, function () {
					
				});
		});
	},
	delete(axios, id) {
		return new Promise(function (resolve) {
			axios
				.delete('/sales/orders/' + id + '/')
				.then(function () {
					resolve(true);
				}, function () {
					
				});
		});
	},
	paid(axios, order, paid) {
		return new Promise(function (resolve) {
			axios
				.put('/sales/orders/' + order.id + '/' + paid + '/')
				.then(function () {
					resolve(true);
				}, function () {
					
					alert('Der opstod en fejl');
				});
		});
	},
	invoice(axios, order, invoice) {
		return new Promise(function (resolve) {
			axios.post('/integrations/economic/invoices/', {
				invoice: invoice,
				order: order
			}).then(() => {
				resolve(true);
			}, function (test, test2) {
				
				alert('Fakturaen kunne ikke oprettes, måske der varenumrene ikke findes? (' + test.response.data.message + ')');
			});
		});
	}
};